import anime from 'animejs'
import barba from '@barba/core';

export default class{

	constructor(){
        this.linkCircleClass = "js-link-circle";
        this.enterCircleTimeline = []
        this.leaveCircleTimeline = []
        this.enterArrowTimeline = []

        barba.hooks.afterOnce(() => {
            this.init()
        });
        barba.hooks.after(() => {
            this.init()
        });
    }
    
    init (){        
        this.linkCircles = document.querySelectorAll('.' + this.linkCircleClass)
        if(this.linkCircles.length > 0){
            this.linkCircles.forEach((el,i) => {
                this._mouseEnter(el,i)
                this._mouseLeave(el,i)
            })
        }
    }
    _mouseEnter(el,i){
        if(el){
            const circle = el.querySelector('.js-circle-link__circle')
            const arrow = el.querySelector('.js-circle-link__arrow')

            el.addEventListener('mouseenter', () => {
                if(!el.classList.contains('-active')){
                    el.classList.add('-active')
                    const target = el.getAttribute('target')
                    this.enterCircleTimeline[i] = anime.timeline({ loop : true, autoplay:false})
                    this.enterCircleTimeline[i]
                    .add({
                        targets:circle,
                        strokeDashoffset: 500,
                        duration:1000,
                        easing: 'easeOutQuart'
                    })
                    .add({
                        targets:circle,
                        strokeDashoffset: 0,
                        duration:1000,
                        easing: 'easeInExpo'
                    })
                    .add({
                        targets:circle,
                        rotate: ['-90deg','270deg'],
                        duration:2000,
                        easing: 'easeInOutQuart'
                    },"-=2000")
                    .add({
                        duration:1000,
                        easing: 'easeInExpo'
                    },3000)
                    this.enterCircleTimeline[i].play()
                    
                    this.enterArrowTimeline[i] = anime.timeline({ loop : true })
                    if(target == '_blank'){
                        this.enterArrowTimeline[i]
                        .add({
                            targets:arrow,
                            opacity: [0,0],
                            duration:100,
                            easing: 'linear'
                        })
                        .add({
                            targets:arrow,
                            translateX:['-3px',0],
                            marginTop:['3px',0],
                            opacity: [0,1],
                            duration:500,
                            easing: 'easeInExpo'
                        })
                        .add({
                            targets:arrow,
                            translateX:[0,'3px'],
                            marginTop:[0,'-3px'],
                            opacity: [1,0],
                            duration:1000,
                            easing: 'easeOutExpo'
                        },1500)
                    }else{
                        this.enterArrowTimeline[i]
                        .add({
                            targets:arrow,
                            opacity: [0,0],
                            duration:100,
                            easing: 'linear'
                        })
                        .add({
                            targets:arrow,
                            translateX:['-3px',0],
                            opacity: [0,1],
                            duration:500,
                            easing: 'easeInExpo'
                        })
                        .add({
                            targets:arrow,
                            translateX:[0,'3px'],
                            opacity: [1,0],
                            duration:1000,
                            easing: 'easeOutExpo'
                        },1500)
                    }
                }
            })
        }
    }
    _mouseLeave(el,i){

        const circle = el.querySelector('.js-circle-link__circle')
        const arrow = el.querySelector('.js-circle-link__arrow')

        el.addEventListener('mouseleave', () => {
            if(el.classList.contains('-active')){
                this.enterCircleTimeline[i].pause()
            
                el.classList.remove('-active')

                this.leaveCircleTimeline[i] = anime.timeline()
                this.leaveCircleTimeline[i]
                .add({
                    targets:circle,
                    strokeDashoffset: 0,
                    duration:1000,
                    easing: 'easeInExpo'
                })
                .add({
                    targets:circle,
                    rotate: '-90deg',
                    duration:1000,
                    easing: 'easeOutExpo'
                },"-=1000")
                
                this.enterArrowTimeline[i].seek(0);
                this.enterArrowTimeline[i].pause()
                anime({
                    targets:arrow,
                    opacity: [0,1],
                    translateX: 0,
                    marginTop: 0,
                    duration:500,
                    easing: 'easeOutExpo'
                })
            }
        })
    }
}